import { GLOBAL_HD_DTU_ID } from './common';

export const checkIsGlobalHDDtu = (datasetId: string) => datasetId.includes(GLOBAL_HD_DTU_ID);
